import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { api } from "../../api/api";
import Table from "../../components/table/Table";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import "./role.css";
import { debounce } from "lodash";

const modules = [
  { key: "dashboard", label: "Dashboard" },
  { key: "roleManagement", label: "Role Management" },
  { key: "userManagement", label: "Employee Management" },
  { key: "categoryManagement", label: "Category Management" },
  { key: "courseManagement", label: "Course Management" },
  { key: "ticketManagement", label: "Ticket Management" },
  { key: "paymentManagement", label: "Payment Management" },
];

const RoleList = () => {
  const [roleName, setRoleName] = useState("");
  const [data, setData] = useState([]);
  const { currUserData } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [popupShow, setPopupShow] = useState(false);
  const [editingRoleData, setEditingRoleData] = useState("");

  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState([]);
  const [selectAll, setSelectAll] = useState({
    write: false,
    read: false,
    delete: false,
  });

  console.log(editingRoleData, "editingRoleData sss");

  const initializePermissions = () => {
    const defaultPermissions = modules.map((mod) => ({
      feature: mod.key,
      read: false,
      write: false,
      delete: false,
    }));
    setPermissions(defaultPermissions);
    setSelectAll({ read: false, write: false, delete: false });
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getRoleData(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const getRoleData = async (term = "") => {
    setIsLoading(true);
    try {
      const res = await api(
        `api/v1/role/getRoles?page=1&limit=5&search=${term}`,
        "",
        "get",
        currUserData?.token,
        ""
      );
      if (res?.success) {
        setData(res.data.items);
        setTotalCount(res?.data?.totalItems);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
    setIsLoading(false);
  };

  const handlePermissionChange = (index, type) => {
    setPermissions((prev) =>
      prev.map((perm, i) =>
        i === index ? { ...perm, [type]: !perm[type] } : perm
      )
    );
  };

  const handleSelectAll = (type) => {
    const newState = !selectAll[type];
    setSelectAll((prev) => ({ ...prev, [type]: newState }));
    setPermissions((prev) =>
      prev.map((perm) => ({ ...perm, [type]: newState }))
    );
  };

  const AddRole = async () => {
    const formattedPermissions = modules
      .map((module, index) => ({ feature: module.key, ...permissions[index] }))
      .filter((perm) => perm.read || perm.write || perm.delete);

    const payload = {
      name: roleName,
      permissions: formattedPermissions,
      status: 1,
    };
    const editPayload = {
      permissions: formattedPermissions,
    };

    console.log(payload, "role");
    if (editingRoleData) {
      const res = await api(
        `api/v1/role/updateRole/${editingRoleData?._id}`,
        editPayload,
        "put",
        currUserData?.token,
        ""
      );
      if (res && res.success) {
        console.log("API Response:", res);
        setPopupShow(false);
        getRoleData();
        resetForm();
        setEditingRoleData("");
      }
    } else {
      const res = await api(
        "api/v1/role/addRole",
        payload,
        "post",
        currUserData?.token,
        ""
      );
      if (res && res.success) {
        console.log("API Response:", res);
        setPopupShow(false);
        getRoleData();
        resetForm();
      }
    }
  };

  const DeleteRole = async (id) => {
    const res = await api(
      `api/v1/role/deleteRole/${id}`,
      {},
      "delete",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      getRoleData();
    }
  };

  const resetForm = () => {
    setRoleName("");
    initializePermissions();
    // setIsEdit(false);
  };

  const loadRoleForEdit = (roleData) => {
    setRoleName(roleData?.name);
    setEditingRoleData(roleData);

    const mappedPermissions = modules.map((mod) => {
      const found = roleData?.permissions.find((p) => p.feature === mod.key);
      return {
        feature: mod.key,
        read: found?.read || false,
        write: found?.write || false,
        delete: found?.delete || false,
      };
    });

    setPermissions(mappedPermissions);

    console.log(roleData, mappedPermissions, "loasd");
  };

  const handleEdit = (editData) => {
    loadRoleForEdit(editData);
    setPopupShow(true);
  };

  const columns = [
    {
      Header: "Role Name",
      accessor: "name",
    },
    {
      Header: "Action",
      accessor: "",
      Cell: ({ row }) => (
        <div class="dropdown">
          <span
            data-bs-toggle="dropdown"
            style={{ cursor: "pointer" }}
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-v"></i>
          </span>
          <ul class="dropdown-menu">
            <li>
              <span
                className="me-3 cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleEdit(row.original);
                }}
              >
                Edit
              </span>
            </li>
            <li>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => DeleteRole(row.original._id)}
              >
                Delete
              </span>
            </li>
          </ul>
        </div>
      ),
    },
  ];
  useEffect(() => {
    getRoleData();
    initializePermissions();
  }, [pageIndex, pageSize]);
  return (
    <div className="p-40">
      <div className="page_heading mb-4">
        <p className="heading">Role</p>
        <button
          className="btn_primary"
          onClick={() => {
            setPopupShow(true);
            resetForm();
          }}
        >
          + Add Role
        </button>
      </div>
      <div className="row">
        <Table
          columns={columns}
          data={data}
          isLoading={isLoading}
          onSearch={handelSearch}
          totalCount={totalCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
        />
      </div>

      <CustomPopup
        show={popupShow}
        close={setPopupShow}
        title="Add Permissions"
        width="lg"
        closeIcon={true}
      >
        <div className="permission_data">
          <label className="input_lable">Role Name</label>
          <input
            type="text"
            value={roleName}
            onChange={(e) => {
              let value = e.target.value;

              // Remove all non-alphanumeric and non-space characters
              value = value.replace(/[^a-zA-Z0-9 ]/g, "");

              // Prevent first character from being a digit
              if (value.length === 1 && /^[0-9]/.test(value)) {
                return; // Don't update if first char is a number
              }

              setRoleName(value);
            }}
            placeholder="Enter role name"
            className="custom_input mb-3"
            disabled={editingRoleData}
          />

          <table className="w-100" cellPadding="10">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Module</th>
                <th>
                  <span>Write</span>
                  <input
                    type="checkbox"
                    checked={selectAll.write}
                    onChange={() => handleSelectAll("write")}
                  />
                </th>
                <th>
                  <span>Read</span>
                  <input
                    type="checkbox"
                    checked={selectAll.read}
                    onChange={() => handleSelectAll("read")}
                  />
                </th>
                <th>
                  <span>Delete</span>
                  <input
                    type="checkbox"
                    checked={selectAll.delete}
                    onChange={() => handleSelectAll("delete")}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {modules.map((module, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{module.label}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={permissions[index]?.write}
                      onChange={() => handlePermissionChange(index, "write")}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={permissions[index]?.read}
                      onChange={() => handlePermissionChange(index, "read")}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={permissions[index]?.delete}
                      onChange={() => handlePermissionChange(index, "delete")}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            onClick={() => {
              AddRole();
            }}
            className="btn_primary px-4 mx-auto mt-4 w-100"
          >
            Submit
          </button>
        </div>
      </CustomPopup>
    </div>
  );
};

export default RoleList;
